import RecoveryPassInfo from './RecoveryPassInfo';

export { RecoveryPassInfo };
export default RecoveryPassInfo;
